import apiClient from "./apiClient";

/* ================= CORE ================= */

// Create a new group
export const createGroup = (data) =>
  apiClient.post("/api/group", data);

// Get group details by ID (member only)
export const getGroupById = (groupId) =>
  apiClient.get(`/api/group/${groupId}`);

// Get all groups of the logged-in user
export const getMyGroups = () =>
  apiClient.get("/api/groups");

// Fetch all messages of a group (with optional pagination)
export const getGroupMessages = (groupId, limit = 50, skip = 0) =>
  apiClient.get(`/api/chat/group/${groupId}/messages?limit=${limit}&skip=${skip}`);

/* ================= MEMBERS ================= */

// Add member (admin only)
export const addGroupMember = (groupId, userId) =>
  apiClient.post(`/api/group/${groupId}/members`, { userId });

// Remove member (admin only)
export const removeGroupMember = (groupId, userId) =>
  apiClient.delete(`/api/group/${groupId}/members/${userId}`);

// Leave group
export const leaveGroup = (groupId) =>
  apiClient.post(`/api/group/${groupId}/leave`);

/* ================= ROLES ================= */

// Promote member to admin (owner only)
export const promoteToAdmin = (groupId, userId) =>
  apiClient.post(`/api/group/${groupId}/promote/${userId}`);

// Demote admin to member (owner only)
export const demoteAdmin = (groupId, userId) =>
  apiClient.post(`/api/group/${groupId}/demote/${userId}`);

// Transfer ownership
export const transferGroupOwnership = (groupId, newOwnerId) =>
  apiClient.post(`/api/group/${groupId}/transfer`, {
    newOwnerId
  });

/* ================= MODERATION ================= */

// Mute a member (admin only)
export const muteGroupMember = (groupId, userId) =>
  apiClient.post(`/api/group/${groupId}/mute/${userId}`);

/* ================= DELETE ================= */

// Delete group (owner only)
export const deleteGroup = (groupId) =>
  apiClient.delete(`/api/group/${groupId}`);
